import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";

export function getFeatureFlagOverride(
  featureFlag: FeatureFlagKey,
): boolean | undefined {
  try {
    const override = localStorage?.getItem(`override-${featureFlag}`);
    if (!override || (override !== "false" && override !== "true")) {
      return undefined;
    }
    return override === "true";
  } catch (error) {
    return undefined;
  }
}
